.wrap {
	display: grid;
	gap: var(--space-2);
	padding: var(--space-3) var(--space-4);
	background: var(--surface-card);
	border: 1px solid var(--border);
	border-radius: var(--radius-md);
	box-shadow: var(--shadow-card);
}

.row {
	display: flex;
	align-items: center;
	gap: var(--space-3);
}

.icon {
	color: var(--ink-muted);
	flex: none;
	display: inline-flex;
}

.text {
	display: grid;
	line-height: 1.2;
	min-width: 0;
	flex: 1;
}

.label {
	font-size: 0.75rem;
	color: var(--ink-muted);
}

.value {
	min-width: 0;
	overflow-wrap: anywhere;
}

.action {
	margin-left: auto;
	flex: none;
	display: flex;
	gap: var(--space-2);
}

/* Styled by element so a call site passes a plain <button> — or a plain
   <a>, which is what the website's export download has to be. */
.action button,
.action a {
	display: inline-flex;
	align-items: center;
	gap: var(--space-2);
	background: none;
	border: 1px solid var(--border);
	border-radius: var(--radius-md);
	padding: var(--space-2) var(--space-3);
	font: inherit;
	font-size: 0.85rem;
	font-weight: 600;
	color: var(--ink-muted);
	cursor: pointer;
	white-space: nowrap;
	text-decoration: none;
}

.action button:hover:not(:disabled),
.action a:hover {
	color: var(--ink);
	background: var(--surface-input);
}

.action button:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.hint {
	margin: 0;
	font-size: 0.8rem;
	line-height: 1.4;
	color: var(--ink-muted);
	text-wrap: pretty;
}
